import { useAtomValue } from 'jotai';
import { metricKeys } from '@pulse/metrics';
import { panelsAtom, enableDodAtom } from '../../atoms';
import useFetchMetrics from '../../hooks/useFetchMetrics';

export const NETWORK_METRICS = [
  metricKeys.mins_with_0_nwr_failure,
  metricKeys.mins_with_4xx_nwr_failure,
  metricKeys.mins_with_5xx_nwr_failure,
  metricKeys.mins_with_high_nwr_duration,
];

function useNetworkMetricsData() {
  const panels = useAtomValue(panelsAtom);
  const enableDod = useAtomValue(enableDodAtom);

  return useFetchMetrics({
    metrics: NETWORK_METRICS,
    enableDoD: enableDod,
    panelEnabled: !!panels.network,
  });
}

export default useNetworkMetricsData;
